module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Forward-443ec2c1243ca860b2ba06c21363aeef.svg";